import { Inject, Injectable } from "@angular/core";
import { LogBookRootScopeService } from "app/shared/model/app.model";
import { CookieService } from "ngx-cookie-service";

@Injectable({
	providedIn: 'root'
})
export class SimulateLogUserRoleService {
		constructor(
			private cookieService: CookieService,
			@Inject('$rootScope') private $rootScope: LogBookRootScopeService)
		{
			this.cookieService = cookieService;
		};

	get forceAdminFlag(): string {
		return this.cookieService.get('force-log-admin');
	}
	
	cancelForceAdmin() {
		this.cookieService.delete('force-log-admin');
	}
	
	simulateLogUserRole(logId: number, roleId: number) {
		let simulatedRoles = this.getSimulatedLogUserRoles();
		if( roleId )
			simulatedRoles[logId] = roleId;
		else
			delete simulatedRoles[logId];
		
		let cookieString = Object.keys(simulatedRoles).map(lId => {
				return lId+'='+simulatedRoles[parseInt(lId)];
			}).join('; ');
		this.cookieService.set('simulate-log-user-role', cookieString);
		this.$rootScope.$broadcast('simulated-log-role');
	}
	
	getSimulatedLogUserRole(logId: number) {
		let simulatedRoles = this.getSimulatedLogUserRoles();
		return simulatedRoles[logId];
	}
	
	private getSimulatedLogUserRoles() {
		let cookie = this.cookieService.get('simulate-log-user-role');
		let simulatedRoles: {
			[logId: number]: number
		} = {};

		if( cookie )
			cookie.split(';').forEach(val => {
				let splitVal = val.split('=');
				simulatedRoles[parseInt(splitVal[0].trim())] = parseInt(splitVal[1].trim());
			})
			
		return simulatedRoles;
	}
	
}